import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import Hero from "../components/home/Hero";
import RecognizedSection from "../components/home/RecognizedSection";
import CoursesSection from "../components/home/CoursesSection";
import AdvantageSection from "../components/home/AdvantageSection";

import DemoBook from "../components/home/DemoBook";

import Testimonials from "../components/home/Testimonials";
import Banner from "../components/home/Banner";
import SEO from "../components/SEO";

const Home = () => {
    const [searchParams] = useSearchParams();

    useEffect(() => {
        // Check both router params (after hash) and window params (before hash)
        let ref = searchParams.get("ref");
        if (!ref) {
            const windowParams = new URLSearchParams(window.location.search);
            ref = windowParams.get("ref");
        }

        if (ref) {
            axios.post(
                `https://api.skillascent.in/api/BulkSms/save?ref=${encodeURIComponent(ref)}`
            )
                .then(() => console.log("Lead saved successfully"))
                .catch(err => console.error("Lead tracking failed", err));
        }
    }, [searchParams]);

    const homeSchema = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "@id": "https://www.skillascent.in/#webpage",
        "url": "https://www.skillascent.in/",
        "name": "Skill Ascent | Top Online Skill Development & Industry Training Courses India",
        "description": "Skill Ascent provides career-transforming online certification courses in IT, Python Full Stack, Data Science, AI/ML, Digital Marketing, Graphic Design, Video Editing, Agriculture & Engineering with job placement assistance.",
        "isPartOf": {
            "@id": "https://www.skillascent.in/#website"
        },
        "about": {
            "@id": "https://www.skillascent.in/#organization"
        }
    };

    return (
        <>
            <SEO
                title="Top Online Skill Development & Industry Training Courses India | Skill Ascent"
                description="Skill Ascent provides career-transforming online certification courses in IT, Python Full Stack, Data Science, AI/ML, Digital Marketing, Graphic Design, Video Editing, Agriculture & Engineering with job placement assistance."
                keywords="Skill Ascent, online courses India, full stack development course, data science training, AI ML courses, digital marketing course online with certificate, graphic design certification, video editing course, IT training institute India"
                canonicalPath="/"
                schemaData={homeSchema}
                breadcrumbs={[{ name: "Home", url: "/" }]}
            />
            <div id="home"><Hero /></div>
            <RecognizedSection />
            <div id="courses"><CoursesSection /></div>
            <DemoBook />
            <AdvantageSection />
         
            <Testimonials />
            
            <Banner />
        </>
    );
};

export default Home;
